import axios from 'axios'

import { FASTAPI_CONFIG } from '@/config/fastapi'
// import { useDialogService } from '@/services/dialogService'
import { useAuthStore } from '@/stores/authStore'

/**
 * Setup global axios interceptors for authentication
 */
export function setupAxiosInterceptors() {
  // Request interceptor to add auth token
  axios.interceptors.request.use(
    (config) => {
      // Only add token for requests to our FastAPI backend
      const isBackendRequest =
        FASTAPI_CONFIG.BASE_URL === ''
          ? config.url?.startsWith('/')
          : config.url?.startsWith(FASTAPI_CONFIG.BASE_URL)
      if (isBackendRequest) {
        try {
          const authStore = useAuthStore()
          const token = authStore.getAccessToken()

          if (token) {
            config.headers.Authorization = `Bearer ${token}`
          }
        } catch (error) {
          console.warn('Failed to get auth token for axios request:', error)
        }
      }

      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  // Response interceptor to handle token refresh and license expired
  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config

      // 许可证过期：跳转到到期页面
      if (error.response?.status === 503) {
        const data = error.response?.data
        if (
          data?.code === 'license_expired' ||
          data?.detail === 'license_expired'
        ) {
          if (!window.location.pathname.includes('/license-expired')) {
            window.location.href = '/license-expired'
          }
          return Promise.reject(error)
        }
      }

      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true

        try {
          const authStore = useAuthStore()

          // If user is not initialized yet, don't show dialog - let router guard handle redirect
          if (!authStore.isInitialized || !authStore.currentUser) {
            console.log(
              'Global axios: 401 error during initialization, will redirect to login page'
            )
            return Promise.reject(error)
          }

          console.log(
            'Global axios interceptor: Token refresh disabled, showing login dialog...'
          )
          // const authStore = useAuthStore()
          // const success = await authStore.refreshAccessToken()
          //
          // if (success) {
          //   // Retry original request with new token
          //   const newToken = authStore.getAccessToken()
          //   if (newToken) {
          //     originalRequest.headers.Authorization = `Bearer ${newToken}`
          //     return axios(originalRequest)
          //   }
          // }

          // 精简模式 /workflow2 已显示登录弹窗，不重定向避免循环刷新
          if (!window.location.pathname.startsWith('/workflow2')) {
            console.log('登录已过期，直接跳转到登录页面')
            window.location.href = '/login'
          }
        } catch (refreshError) {
          console.warn('Token refresh failed:', refreshError)
        }
      }

      return Promise.reject(error)
    }
  )
}
